import Vue from 'vue'
import axios from 'axios'
// 响应时间
axios.defaults.timeout = 5 * 1000;
// 配置cookie
axios.defaults.withCredentials = false;
// 配置请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// axios.defaults.headers.[Strict-Transport-Security] = max-age=31536000; // 强制使用https进行访问,有效期1年

// POST传参序列化(添加请求拦截器)
//发送请求前拦截,加上token
axios.interceptors.request.use(
  config => {
    if(config.url.indexOf("getToken") == -1 && localStorage.tokenCMS) {
      config.headers.Authorization = "Pig "  + localStorage.tokenCMS
    }
    return config;
  },
  err => {
    console.error('请求错误')
    return Promise.reject(err)
  }
)
// // 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  config => {
    if (config.data.code === 40001) {
      Vue.prototype.$logout()
    } else if (config.data.code === 1) {
      return config;
    } else {
      return config;
    }
  },
  err => {
    return Promise.reject(err)
  },
)

// 发送请求
export function post (url, params) {
  return new Promise(function(resolve, reject) {
    axios
      .post(url, params)
      .then(
        res => {
          resolve(res.data)
        },
        err => {
          reject(err.data)
        }
      )
      .catch(err => {
        reject(err.data)
      })
  }).catch(reason => {
    console.log('catch:', reason);
  })
}
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  }).catch(reason => {
    console.log('catch:', reason);
  })
}
export function put (url, params) {
  return new Promise(function(resolve, reject) {
    axios
      .put(url, params)
      .then(
        res => {
          resolve(res.data)
        },
        err => {
          reject(err.data)
        }
      )
      .catch(err => {
        reject(err.data)
      })
  }).catch(reason => {
    console.log('catch:', reason);
  })
}
export function deleteFn (url, params) {
  return new Promise(function(resolve, reject) {
    axios
      .delete(url, {data: params})
      .then(
        res => {
          resolve(res.data)
        },
        err => {
          reject(err.data)
        }
      )
      .catch(err => {
        reject(err.data)
      })
  }).catch(reason => {
    console.log('catch:', reason);
  })
}
